import type { Observable } from 'rxjs';

import { createProviderToken } from '@core/common-legacy';
import type { ConversationStartersContext } from '@core/tellent-assistant-types';

/**
 * Host-provided observable of the current context used to fetch
 * conversation starters for the assistant's empty state.
 *
 * Emit `null` when no context is available; the logic layer defaults
 * to `{ type: 'recruitment_general' }`.
 */
export const {
  provide: provideTellentConversationStartersContext,
  inject: injectTellentConversationStartersContext,
} = createProviderToken<Observable<ConversationStartersContext | null>>(
  'TELLENT_CONVERSATION_STARTERS_CONTEXT',
)(false);
